import { render } from "./unitExperiment.vue?vue&type=template&id=1d9308c6&scoped=true&ts=true&lang=pug"
import script from "./unitExperiment.vue?vue&type=script&lang=ts"
export * from "./unitExperiment.vue?vue&type=script&lang=ts"

import "./unitExperiment.vue?vue&type=style&index=0&id=1d9308c6&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9308c6"]])

export default __exports__